export default "/images/vendor/flag-icon-css/flags/4x3/pt.svg?96475126e7232ee3558e6fd593a37bec";